import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip, Colors, AnalyticsComponent } from '@inplayer-org/inplayer-ui';
import styled, { css } from 'styled-components';
import { FaCode } from 'react-icons/fa';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';

// actions
import { openModal } from 'ducks/merchantDucks/modal/actions';

// components
import { StyledReactIcon } from 'pages/MerchantPages/Audience/components/AudienceDetailsBox';
import EmbedModal from 'pages/MerchantPages/Assets/components/Navbar/modals/EmbedModal';

const StyledIcon = styled(StyledReactIcon)<{ disabled?: boolean }>`
  vertical-align: middle;
  margin-left: 0.5rem;

  :hover {
    transform: scale(1.2);
    transition: 0.2s ease;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;

      :hover {
        & > svg {
          cursor: default;
        }
      }
    `}
`;

const ItemEmbed: FC = () => {
  const dispatch = useDispatch();

  const showEmbedModal = () => {
    dispatch(openModal(ModalNames.Embed));
  };

  return (
    <AnalyticsComponent>
      {({ pages, tracker, merchantId, ip }) => (
        <>
          <Tooltip content="Get asset embed code">
            <StyledIcon
              as={FaCode}
              color={Colors.concrete}
              onClick={() => {
                tracker.track({
                  event: 'click',
                  type: 'icon',
                  tag: 'button_get_asset_embed_code',
                  pages,
                  merchantId,
                  ip,
                });
                return showEmbedModal();
              }}
            />
          </Tooltip>
          <EmbedModal />
        </>
      )}
    </AnalyticsComponent>
  );
};

export default ItemEmbed;
